import React from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { useDispatch } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import PropTypes from 'prop-types';
import { createNewPost } from '../../../redux/actions/_news_actions';

const ConfirmDeleteView = (props) => {
  const { data, open, handleOpen, CancelDelete } = props;
  const dispatch = useDispatch();

  const handleClose = () => {
    handleOpen((prevState) => ({
      ...prevState,
      confirm: false,
    }));
  };

  const ConfirmDelete = () => {
    const tempPost = data;
    tempPost.Status = false;
    dispatch(createNewPost(tempPost, true, false));
    handleClose();
  };

  if (!open) return null;

  return (
    <Dialog onClose={handleClose} title="¿Quieres eliminar esta noticia?">
      <div style={{ padding: 20 }}>
        <p style={{ fontSize: '1.9rem' }}>Una vez eliminada no podrás recuperar la noticia</p>
      </div>
      <DialogActionsBar>
        <button type="button" className="k-button" onClick={CancelDelete}>
          Cancelar
        </button>
        <button type="button" className="k-button" onClick={ConfirmDelete}>
          Confirmar
        </button>
      </DialogActionsBar>
    </Dialog>
  );
}; 

ConfirmDeleteView.propTypes = {
  data: PropTypes.objectOf(PropTypes.any),
  open: PropTypes.bool,
  handleOpen: PropTypes.func,
  CancelDelete: PropTypes.func,
};

ConfirmDeleteView.defaultProps = {
  data: {},
  open: false,
  handleOpen: () => {},
  CancelDelete: () => {},
};

export default ConfirmDeleteView;
